import { initHowlerAudioPatches } from '~/utils/sound';

export default defineNuxtPlugin(() => {
    initHowlerAudioPatches();
});
